import { z } from "zod";
import { UIElementType } from "../../../AppConstants";
import { t } from "i18next";

const getGrossBranchSchema = (lookUpData) => {
    console.log("Inside getGrossBranchSchema lookUpData ::::", lookUpData);
    return z.object({
        ServiceType: z
            .object({
                id: z.string(),
                label: z.string(),
            })
            .nullable()
            .refine((value) => value !== null && value?.id !== null, {
                message: "Service Type is required",
            })
            .describe(
                JSON.stringify({
                    elementType: UIElementType.DROPDOWN,
                    inputLabel: t("grossBranchList.serviceTypeName"),
                    isMultiSelect: false,
                    isRequired: true,
                    options: lookUpData.serviceTypeList ? lookUpData.serviceTypeList : []
                })
            ),
        Sector: z
            .object({
                id: z.string(),
                label: z.string(),
            })
            .nullable()
            .refine((value) => value !== null && value?.id !== null, {
                message: "Sector is required",
            })
            .describe(
                JSON.stringify({
                    elementType: UIElementType.DROPDOWN,
                    inputLabel: t("grossBranchList.sectorName"),
                    isMultiSelect: false,
                    isRequired: true,
                    options: lookUpData.sectorList ? lookUpData.sectorList : []
                })
            ),
        Branch: z
            .object({
                id: z.string(),
                label: z.string(),
            })
            .nullable()
            .refine((value) => value !== null && value?.id !== null, {
                message: "Branch is required",
            })
            .describe(
                JSON.stringify({
                    elementType: UIElementType.DROPDOWN,
                    inputLabel: t("grossBranchList.branchName"),
                    isMultiSelect: false,
                    isRequired: true,
                    options: lookUpData.branchList ? lookUpData.branchList : []
                })
            ),
        ContractsGrossMargin: z.union([z.literal(0), z.number().positive()])
            .nullable()
            .refine(value => value === null || value >= 0, {
                message: "If entered, the number must be positive or zero",
            }).describe(
                JSON.stringify({
                    inputType: "number",
                    elementType: UIElementType.TEXTFIELD,
                    inputLabel: t("grossBranchList.contractsGrossMargin"),
                    isRequired: true,
                })
            ),
        JobsGrossMargin: z.union([z.literal(0), z.number().positive()])
            .nullable()
            .refine(value => value === null || value >= 0, {
                message: "If entered, the number must be positive or zero",
            }).describe(
                JSON.stringify({
                    inputType: "number",
                    elementType: UIElementType.TEXTFIELD,
                    inputLabel: t("grossBranchList.jobsGrossMargin"),
                    isRequired: true,
                })
            ),
        CoefficientWarranty: z.union([z.literal(0), z.number().positive()])
            .nullable()
            .refine(value => value === null || value >= 0, {
                message: "If entered, the number must be positive or zero",
            }).describe(
                JSON.stringify({
                    inputType: "number",
                    elementType: UIElementType.TEXTFIELD,
                    inputLabel: t("grossBranchList.coefficientWarranty"),
                    isRequired: true,
                })
            )
    });
};

const getGrossBranchDefaultValue = (value = null) => {
    return {
        ServiceType: value && value.ServiceType ? value.ServiceType : null,
        Sector: value && value.Sector ? value.Sector : null,
        Branch: value && value.Branch ? value.Branch : null,
        ContractsGrossMargin: value && value.ContractsGrossMargin ? value.ContractsGrossMargin : 0,
        JobsGrossMargin: value && value.JobsGrossMargin ? value.JobsGrossMargin : 0,
        CoefficientWarranty: value && value.CoefficientWarranty ? value.CoefficientWarranty : 0
    };
};

const getGrossBranchAPIPostSchema = (countryCode, businessCode) => {
    return {
        countryCode: countryCode,
        businessCode: businessCode,
        grossBranch: [
            {
                GrossBranchId: "",
                TypeId: null,
                SectorId: null,
                BranchId: null,
                ContractsGrossMargin: 0,
                JobsGrossMargin: 0,
                CoefficientWarranty: 0,
                Deleted: false,
                CountryCode: countryCode,
                BusinessCode: businessCode,
            },
        ],
    };
};

const getGrossBranchAPIDeleteSchema = (countryCode, businessCode) => {
    return {
        countryCode: countryCode,
        businessCode: businessCode,
        grossBranch: [
            {
                GrossBranchId: "",
                Deleted: false,
                CountryCode: countryCode,
                BusinessCode: businessCode
            },
        ],
    };
};

const getGrossBranchAuditInfoSchema = () => {
    return {
        auditInfo: [
            {
                Location: "Gross Branch",
                LocationKey: "",
                Action: null,
                shortDesc: null,
                currentState: null,
                previousState: null,
            },
        ],
    };
};

export {
    getGrossBranchSchema,
    getGrossBranchDefaultValue,
    getGrossBranchAPIPostSchema,
    getGrossBranchAPIDeleteSchema,
    getGrossBranchAuditInfoSchema,
};
